export default __webpack_public_path__ + "static/topshot-e9794afe52e8c3f4ab8ace3cca74d6fd.png";